import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { App } from './App'
import {
	getRegistrationTermsOfUse,
	getAttorneyTermsOfUse,
	getBorrowerTermsOfUse,
	getAttorneyPrivacyPolicy,
	getTermsOfUse,
	getPrivacyPolicy,
} from './actions/termsAndPolicies'
import { showFeedback, focusInput } from './actions/login'
import { hideAllMessages } from './actions/messages'
import { defaultState } from './reducers/login'

export function getSafeNavigationTarget(target) {
	if (typeof target !== 'string' || target.length === 0) {
		return null
	}

	if (/^(\/)(?!\/)/.test(target) || /^[?#]/.test(target)) {
		return target
	}

	try {
		const appOrigin = window.location.origin
		const resolved = new URL(target, appOrigin)
		if (!/^https?:$/.test(resolved.protocol)) {
			return null
		}
		if (resolved.origin !== appOrigin) {
			return null
		}
		return `${resolved.pathname}${resolved.search}${resolved.hash}`
	} catch (error) {
		return null
	}
}

export const mapStateToProps = (state) => {
	const { generalMessage, outageMessage } = state.messages
	const { locale, showLanguageDropDown } = state.locale
	const {
		widget,
		showLoading,
		componentDetails,
		componentDetailsOutage,
		productName,
		mode,
	} = state.loginWidget
	const { auth } = state.loginWidget.componentDetails
	return {
		productName,
		mode,
		auth,
		widget,
		showLoading,
		componentDetailsOutage,
		hideWidgetContent: hideWidgetContent(componentDetails, defaultState),
		generalMessage,
		outageMessage,
		locale,
		showLanguageDropDown,
	}
}

export function hideWidgetContent(componentDetails, defaultState) {
	const { outageManagement } = componentDetails
	return (
		(outageManagement && outageManagement.maintenanceMessageFlag === 'Y') ||
		JSON.stringify(componentDetails) ===
			JSON.stringify(defaultState.componentDetails)
	)
}

export const mapDispatchToProps = (dispatch) => {
	return {
		onShowFeedback() {
			dispatch(showFeedback())
		},
		onHideAllMessages() {
			dispatch(hideAllMessages())
		},
		onGetRegistrationTermsOfUse(showTermsFooter) {
			dispatch(getRegistrationTermsOfUse(showTermsFooter))
		},
		onGetAttorneyTermsOfUse() {
			dispatch(getAttorneyTermsOfUse())
		},
		onGetBorrowerTermsOfUse() {
			dispatch(getBorrowerTermsOfUse())
		},
		onGetAttorneyPrivacyPolicy() {
			dispatch(getAttorneyPrivacyPolicy())
		},
		onGetTermsOfUse() {
			dispatch(getTermsOfUse())
		},
		onGetPrivacyPolicy() {
			dispatch(getPrivacyPolicy())
		},
		onFocusInput(elementId, focusedForm) {
			dispatch(focusInput(elementId, focusedForm))
		},
		onChangeLanguageDropDown(event) {
			const safeTarget = getSafeNavigationTarget(event)
			if (safeTarget) {
				window.location.replace(safeTarget)
			}
		},
	}
}

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(App))
